import { render, staticRenderFns } from "./SecondaryNavigation.vue?vue&type=template&id=25d94081"
import script from "./SecondaryNavigation.vue?vue&type=script&lang=js"
export * from "./SecondaryNavigation.vue?vue&type=script&lang=js"
import style0 from "./SecondaryNavigation.vue?vue&type=style&index=0&id=25d94081&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports